import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { Spinner } from '../components/Spinner';

export function RequireAuth() {
  const { firebaseUser, loading } = useAuthStore();
  const location = useLocation();

  if (loading) return <Spinner full />;
  if (!firebaseUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // Firebase enforces email verification server-side is optional; we gate the
  // UI here for UX, but every function still verifies the token independently.
  if (!firebaseUser.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }
  return <Outlet />;
}
